import React from 'react'
import Icon from '../misc/Icons'
import SectionMarker from '../uiKit/SectionMarker'
import QuestionCountBadge from '../uiKit/QuestionCountBadge'
import { getQuestionBodyLabel } from '../../utils/getQuestionBodyLabel'

class SectionSelection extends React.Component {
  constructor(props) {
    super(props)
    this.state = { activeIndex: 0 }
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  componentDidMount() {
    // Capture phase so the modal owns navigation keys before the page below
    // (library/recent/pack list handlers) can act on them.
    document.addEventListener('keydown', this.handleKeyDown, true)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown, true)
  }

  handleKeyDown(e) {
    const { sections, selectSection, hideModal } = this.props
    const count = (sections && sections.length) || 0
    if (e.keyCode === 40) { // down
      e.preventDefault()
      e.stopPropagation()
      this.setState((prev) => ({ activeIndex: Math.min(prev.activeIndex + 1, count - 1) }))
    } else if (e.keyCode === 38) { // up
      e.preventDefault()
      e.stopPropagation()
      this.setState((prev) => ({ activeIndex: Math.max(prev.activeIndex - 1, 0) }))
    } else if (e.keyCode === 13) { // enter
      e.preventDefault()
      e.stopPropagation()
      const section = sections && sections[this.state.activeIndex]
      if (section) selectSection(section.id)
    } else if (e.keyCode === 27) { // escape
      e.preventDefault()
      e.stopPropagation()
      if (hideModal) hideModal()
    } else if (e.keyCode === 32) { // space — swallow so the page below doesn't open a preview
      e.preventDefault()
      e.stopPropagation()
    }
  }

  render() {
    const { item, mode } = this.props
    const { activeIndex } = this.state
    const isQueueMode = mode === 'queue'

    let itemName
    let numOfQuestions
    let isSet

    if (item.name) {
      itemName = item.name
      numOfQuestions = item.questions.length
      isSet = true
    } else {
      itemName = getQuestionBodyLabel(item)
    }

    return (
      <div className={`selectionModal selectionModal--section ${isSet ? ' selectionModal--set' : ''}`}>
        <div className='selectionModal-header'>
          <div className='selectionModal-header-title'>
            {isQueueMode ? 'Add to Queue' : 'Play Now'}
          </div>
          <div className='selectionModal-header-itemTitle'>
            {itemName}
          </div>

          {isSet &&
          <QuestionCountBadge color='blueLight' questionCount={numOfQuestions} />}

        </div>
        <div className='selectionModal-divider' />
        <div className='selectionModal-selectionList'>
          <div className='selectionModal-selectionList-helpLabel'>
            Select a Class
          </div>
          {this.props.sections.map((section, index) => (
            <div className={`selectionModal-selectionList-item selectionModal-selectionList-item--section${index === activeIndex ? ' selectionModal-selectionList-item--section--active' : ''}`} key={index} onClick={() => { this.props.selectSection(section.id) }} onMouseEnter={() => { this.setState({ activeIndex: index }) }}>
              <SectionMarker section={section} />
              <Icon name={isQueueMode ? 'queue' : 'play'} />
              <SectionMarker section={section} type='colorOnly' />
            </div>
          ))}

        </div>

      </div>

    )
  }
}

export default SectionSelection
